export const ACCOUNT = "account";
export const ADMIN = "admin";
export const TRAVELLER = "traveller";
export const ADMIN_ACCOUNTS = "adminAccounts";
export const ACCOUNT_TRAVELLER = "accountTraveller";

export const UPDATE_ADMIN_INFO = "adminInfo";
export const UPDATE_ADMIN_BLOCKED = "blocked";
export const UPDATE_ADMIN_TOTAL_ACCOUNTS = "accountCount";
